<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/frameworks']" appearance="plain" variant="neutral">&larr; Back to UI Frameworks</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>WebAwesome</h1>
					<p waBody="m" waText>Modern, accessible web component library &mdash; buttons, cards, tabs, dialogs, grids, stacks, inputs, overlays, and layout primitives, all wrapped as type-safe CRTP Java builders with dark-mode theming. WebAwesomePageConfigurator injects the CSS/JS bundles and angular-awesome loader module automatically.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:web-awesome</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.webawesome</p>
					<p waBody="s" waText>Built on: WebAwesome 1.0</p>
				</div>
				<wa-details open summary="Installation">
					<div class="wa-stack wa-gap-xs">
						@if (!useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
								<markdown [data]="mdContent_48" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
						@if (useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
								<markdown [data]="mdContent_49" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Features (8)">
					<div class="wa-stack wa-gap-xs">
						<p waBody="s" waColorText="quiet" waText>Component parity &mdash; Wa&#42; wrappers mirror WebAwesome web components &#40;buttons, inputs, overlays, layout primitives&#41;</p>
						<p waBody="s" waColorText="quiet" waText>CRTP fluent setters for Variant, Appearance, Placement, and Size attributes</p>
						<p waBody="s" waColorText="quiet" waText>Java-native hydration &mdash; WebAwesomePageConfigurator injects CSS/JS bundles and body theme classes</p>
						<p waBody="s" waColorText="quiet" waText>Dark-mode theming support with configurable theme paths</p>
						<p waBody="s" waColorText="quiet" waText>TypescriptIndexPageConfigurator exported for cross-plugin asset reuse</p>
						<p waBody="s" waColorText="quiet" waText>Layout components: WaGrid, WaStack, WaCluster for responsive layouts</p>
						<p waBody="s" waColorText="quiet" waText>Card, Tag, Button, Divider, Text components with appearance variants</p>
						<p waBody="s" waColorText="quiet" waText>Modular extensibility &mdash; single Maven module exports all component packages</p>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Quick Start">
					<markdown [data]="mdContent_50" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="SPI Extension Points">
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
							<wa-tag pill variant="success">provides TypescriptIndexPageConfigurator</wa-tag>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="Prerequisites">
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://webawesome.com/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/WebAwesome</wa-tag>
				</div>
			</div>
		</wa-card>
		<div class="wa-stack wa-gap-m">
			<h2 waHeading="l" waText>Components &#40;91&#41;</h2>
			<p waBody="m" waText>Click any component to see its full API &mdash; properties, constructors, methods, events, slots, and examples.</p>
			<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaPage</h4>
						<p waBody="s" waColorText="quiet" waText>Full application shell with banner, header, navigation, main, aside, and footer slots. Provides responsive layout with mobile navigation drawer, sticky sections, and configurable column widths.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">11 props</wa-tag>
							<wa-tag pill variant="neutral">18 methods</wa-tag>
							<wa-tag pill variant="neutral">2 slots</wa-tag>
							<wa-tag pill variant="success">2 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-page']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaPageBanner</h4>
						<p waBody="s" waColorText="quiet" waText>Top banner slot for product-level navigation, announcements, or branding above the header.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">1 slots</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-page-banner']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaPageHeader</h4>
						<p waBody="s" waColorText="quiet" waText>Header slot for branding, primary actions, and top-level navigation. Sticky by default.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">1 slots</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-page-header']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaPageSubHeader</h4>
						<p waBody="s" waColorText="quiet" waText>Sub-header below the main header for secondary navigation, breadcrumbs, or contextual actions.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">1 slots</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-page-sub-header']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaPageContent</h4>
						<p waBody="s" waColorText="quiet" waText>Page content wrapper that holds the main, aside, and navigation columns.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">1 slots</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-page-content']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaPageContentsMain</h4>
						<p waBody="s" waColorText="quiet" waText>Primary content area within the page. Receives the main body content and router outlet.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">1 slots</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-page-contents-main']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaPageContentsMainHeader</h4>
						<p waBody="s" waColorText="quiet" waText>Header within the main content area for page-level headings and actions.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">1 slots</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-page-contents-main-header']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaPageContentsMainFooter</h4>
						<p waBody="s" waColorText="quiet" waText>Footer within the main content area for pagination or page-level actions.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">1 slots</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-page-contents-main-footer']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaPageContentsAside</h4>
						<p waBody="s" waColorText="quiet" waText>Aside/sidebar content area for secondary content like table of contents, filters, or related links.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">1 slots</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-page-contents-aside']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaPageContentsNavigation</h4>
						<p waBody="s" waColorText="quiet" waText>Navigation drawer for side menu. On mobile, renders as a slide-out drawer controlled by navOpen.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">1 slots</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-page-contents-navigation']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaPageContentsNavigationHeader</h4>
						<p waBody="s" waColorText="quiet" waText>Branding area inside the navigation drawer.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">1 slots</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-page-contents-navigation-header']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaPageContentsNavigationFooter</h4>
						<p waBody="s" waColorText="quiet" waText>Footer links inside the navigation drawer.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">1 slots</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-page-contents-navigation-footer']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaPageNavigationToggle</h4>
						<p waBody="s" waColorText="quiet" waText>Burger button to toggle the mobile navigation drawer. Auto-hidden on desktop.</p>
						<div class="wa-cluster wa-gap-xs"></div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-page-navigation-toggle']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaPageNavigationToggleIcon</h4>
						<p waBody="s" waColorText="quiet" waText>Icon displayed inside the navigation toggle button.</p>
						<div class="wa-cluster wa-gap-xs"></div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-page-navigation-toggle-icon']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaPageFooter</h4>
						<p waBody="s" waColorText="quiet" waText>Page footer slot for copyright notices, legal links, and site-wide actions.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">1 slots</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-page-footer']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaPageMenu</h4>
						<p waBody="s" waColorText="quiet" waText>Menu slot inside the navigation drawer for tree-based navigation.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">1 slots</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-page-menu']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaPageSkipToContent</h4>
						<p waBody="s" waColorText="quiet" waText>Accessibility skip-to-content link that appears on keyboard focus for screen reader users.</p>
						<div class="wa-cluster wa-gap-xs"></div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-page-skip-to-content']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaPageDialogWrapper</h4>
						<p waBody="s" waColorText="quiet" waText>Dialog wrapper for modal overlays. Ensures dialogs render above the page shell.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">1 slots</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-page-dialog-wrapper']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaStack</h4>
						<p waBody="s" waColorText="quiet" waText>Vertical stack layout with configurable gap between children</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">1 props</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-stack']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaCluster</h4>
						<p waBody="s" waColorText="quiet" waText>Horizontal cluster layout with wrapping and configurable gap</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">1 props</wa-tag>
							<wa-tag pill variant="neutral">1 methods</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-cluster']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaGrid</h4>
						<p waBody="s" waColorText="quiet" waText>CSS Grid layout with configurable min column size and gap</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">2 props</wa-tag>
							<wa-tag pill variant="neutral">1 methods</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-grid']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaSplit</h4>
						<p waBody="s" waColorText="quiet" waText>Split layout with configurable ratio between two children</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">1 props</wa-tag>
							<wa-tag pill variant="neutral">3 methods</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-split']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaFlank</h4>
						<p waBody="s" waColorText="quiet" waText>Flanking layout with side and main content areas</p>
						<div class="wa-cluster wa-gap-xs"></div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-flank']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaFrame</h4>
						<p waBody="s" waColorText="quiet" waText>Frame layout for constrained content areas with max-width control</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">1 methods</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-frame']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaDiv</h4>
						<p waBody="s" waColorText="quiet" waText>Styled div with WebAwesome token support for padding, margin, border, shadow, and typography</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">3 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-div']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaSplitPanel</h4>
						<p waBody="s" waColorText="quiet" waText>Resizable split panel with draggable divider between two areas</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">5 props</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-split-panel']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaScroller</h4>
						<p waBody="s" waColorText="quiet" waText>Scrollable container with custom scrollbar styling</p>
						<div class="wa-cluster wa-gap-xs"></div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-scroller']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaButton</h4>
						<p waBody="s" waColorText="quiet" waText>A customizable button component with variant, appearance, size, pill, loading, prefix/suffix icon slots, link mode, and form integration.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">20 props</wa-tag>
							<wa-tag pill variant="neutral">1 methods</wa-tag>
							<wa-tag pill variant="warning">3 events</wa-tag>
							<wa-tag pill variant="neutral">3 slots</wa-tag>
							<wa-tag pill variant="success">5 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-button']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaButtonGroup</h4>
						<p waBody="s" waColorText="quiet" waText>Group of buttons rendered inline with shared appearance</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">1 props</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-button-group']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaSplitButton</h4>
						<p waBody="s" waColorText="quiet" waText>Button with attached dropdown for secondary actions</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">3 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-split-button']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaCopyButton</h4>
						<p waBody="s" waColorText="quiet" waText>One-click copy-to-clipboard button with success feedback</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">5 props</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-copy-button']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaCard</h4>
						<p waBody="s" waColorText="quiet" waText>Flexible container to group related content &mdash; images, headers, body text, and footers. Supports appearance variants, size, orientation, and full CSS custom property theming.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">14 props</wa-tag>
							<wa-tag pill variant="neutral">8 methods</wa-tag>
							<wa-tag pill variant="neutral">4 slots</wa-tag>
							<wa-tag pill variant="success">3 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-card']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaCallout</h4>
						<p waBody="s" waColorText="quiet" waText>Inline alert/message banner with variant styling, icon slot, size, and appearance options.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">6 props</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-callout']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaDetails</h4>
						<p waBody="s" waColorText="quiet" waText>Expandable disclosure widget with summary, open/close animation, accordion grouping, and icon customization.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">6 props</wa-tag>
							<wa-tag pill variant="neutral">4 methods</wa-tag>
							<wa-tag pill variant="warning">4 events</wa-tag>
							<wa-tag pill variant="neutral">4 slots</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-details']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaBreadcrumbs</h4>
						<p waBody="s" waColorText="quiet" waText>Breadcrumb navigation trail with customizable separator</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">1 props</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-breadcrumbs']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaBreadcrumbItem</h4>
						<p waBody="s" waColorText="quiet" waText>Individual breadcrumb link item</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">1 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-breadcrumb-item']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaTabGroup</h4>
						<p waBody="s" waColorText="quiet" waText>Tab container organizing content into panels, showing one at a time. Supports top/bottom/start/end placement, auto/manual activation, and custom styling.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">4 props</wa-tag>
							<wa-tag pill variant="neutral">2 methods</wa-tag>
							<wa-tag pill variant="warning">2 events</wa-tag>
							<wa-tag pill variant="neutral">2 slots</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-tab-group']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaTab</h4>
						<p waBody="s" waColorText="quiet" waText>Individual tab header within a tab group</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">4 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-tab']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaTabPanel</h4>
						<p waBody="s" waColorText="quiet" waText>Tab panel content associated with a tab</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">1 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-tab-panel']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaTree</h4>
						<p waBody="s" waColorText="quiet" waText>Hierarchical tree view with expandable items, selection modes, and customizable indent guides.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">5 props</wa-tag>
							<wa-tag pill variant="neutral">3 methods</wa-tag>
							<wa-tag pill variant="warning">1 events</wa-tag>
							<wa-tag pill variant="neutral">1 slots</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-tree']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaTreeItem</h4>
						<p waBody="s" waColorText="quiet" waText>Individual tree node with expandable children, icon, and link support</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">4 props</wa-tag>
							<wa-tag pill variant="neutral">4 methods</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-tree-item']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaDropDown</h4>
						<p waBody="s" waColorText="quiet" waText>Dropdown menu triggered by a button with popover panel, placement, and selection events.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">6 props</wa-tag>
							<wa-tag pill variant="neutral">6 methods</wa-tag>
							<wa-tag pill variant="warning">5 events</wa-tag>
							<wa-tag pill variant="neutral">2 slots</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-drop-down']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaDropdownItem</h4>
						<p waBody="s" waColorText="quiet" waText>Individual dropdown menu item with value and optional prefix/suffix</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">4 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-dropdown-item']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaInput</h4>
						<p waBody="s" waColorText="quiet" waText>Text input with label, hint, placeholder, clearable, password toggle, validation, and rich slot support. Supports all HTML input types including text, password, email, number, date, tel, url, and search.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">18 props</wa-tag>
							<wa-tag pill variant="neutral">1 methods</wa-tag>
							<wa-tag pill variant="warning">6 events</wa-tag>
							<wa-tag pill variant="neutral">5 slots</wa-tag>
							<wa-tag pill variant="success">3 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-input']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaNumberInput</h4>
						<p waBody="s" waColorText="quiet" waText>Numeric input with min/max/step and stepper controls</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">6 props</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-number-input']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaTextArea</h4>
						<p waBody="s" waColorText="quiet" waText>Multi-line text input with resize options, label, hint, rows, maxlength, and appearance customization.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">9 props</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-text-area']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaSelect</h4>
						<p waBody="s" waColorText="quiet" waText>Dropdown select control with label, hint, placeholder, multiple selection, clearable, and filterable options.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">10 props</wa-tag>
							<wa-tag pill variant="neutral">1 methods</wa-tag>
							<wa-tag pill variant="warning">5 events</wa-tag>
							<wa-tag pill variant="neutral">5 slots</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-select']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaSelectOption</h4>
						<p waBody="s" waColorText="quiet" waText>Individual option within a select</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">2 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-select-option']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaCheckbox</h4>
						<p waBody="s" waColorText="quiet" waText>Checkbox input with checked, indeterminate, and disabled states. Supports form integration and custom size.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">6 props</wa-tag>
							<wa-tag pill variant="neutral">3 methods</wa-tag>
							<wa-tag pill variant="warning">1 events</wa-tag>
							<wa-tag pill variant="neutral">1 slots</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-checkbox']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaRadio</h4>
						<p waBody="s" waColorText="quiet" waText>Radio button input</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">3 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-radio']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaRadioGroup</h4>
						<p waBody="s" waColorText="quiet" waText>Radio button group with mutual exclusion, orientation, and label support.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">6 props</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-radio-group']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaSwitch</h4>
						<p waBody="s" waColorText="quiet" waText>Toggle switch for on/off states with label, hint, size, and form integration.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">6 props</wa-tag>
							<wa-tag pill variant="neutral">3 methods</wa-tag>
							<wa-tag pill variant="warning">1 events</wa-tag>
							<wa-tag pill variant="neutral">1 slots</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-switch']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaRange</h4>
						<p waBody="s" waColorText="quiet" waText>Range slider input with min/max/step, label, hint, tooltip, and custom track styling.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">8 props</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-range']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaColorPicker</h4>
						<p waBody="s" waColorText="quiet" waText>Color picker with swatches, opacity, format options, and eyedropper support</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">7 props</wa-tag>
							<wa-tag pill variant="neutral">3 methods</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-color-picker']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaRating</h4>
						<p waBody="s" waColorText="quiet" waText>Star rating input with half-star, custom icon, and readonly support</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">6 props</wa-tag>
							<wa-tag pill variant="neutral">1 methods</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-rating']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaText</h4>
						<p waBody="s" waColorText="quiet" waText>Typography component with heading/body/caption styles and size variants</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">4 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-text']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaTag</h4>
						<p waBody="s" waColorText="quiet" waText>Compact tag/pill component for labeling, categorizing, or indicating status. Supports variant, appearance, size, pill, and removable.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">5 props</wa-tag>
							<wa-tag pill variant="neutral">1 methods</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-tag']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaBadge</h4>
						<p waBody="s" waColorText="quiet" waText>Badge for small counts, labels, or status indicators. Supports variant, appearance, pill, and pulse animation.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">4 props</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-badge']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaIcon</h4>
						<p waBody="s" waColorText="quiet" waText>Icon component supporting Font Awesome families &#40;classic, brands, sharp, sharp-duotone&#41;, library registration, SVG sources, duotone coloring, and accessibility labels.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">9 props</wa-tag>
							<wa-tag pill variant="neutral">1 slots</wa-tag>
							<wa-tag pill variant="success">3 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-icon']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaAvatar</h4>
						<p waBody="s" waColorText="quiet" waText>User avatar with image, initials, or icon fallback</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">5 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-avatar']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaAvatarGroup</h4>
						<p waBody="s" waColorText="quiet" waText>Group of overlapping avatars</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">1 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-avatar-group']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaDivider</h4>
						<p waBody="s" waColorText="quiet" waText>Horizontal or vertical divider line</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">1 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-divider']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaQRCode</h4>
						<p waBody="s" waColorText="quiet" waText>QR code generator with configurable size, error correction, and fill/background colors</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">5 props</wa-tag>
							<wa-tag pill variant="neutral">1 methods</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-qrcode']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaMarkdown</h4>
						<p waBody="s" waColorText="quiet" waText>Markdown renderer with syntax highlighting and optional clipboard support</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">1 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-markdown']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaCarousel</h4>
						<p waBody="s" waColorText="quiet" waText>Image/content carousel with navigation and autoplay</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">3 methods</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-carousel']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaCarouselItem</h4>
						<p waBody="s" waColorText="quiet" waText>Individual slide within a carousel</p>
						<div class="wa-cluster wa-gap-xs"></div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-carousel-item']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaAnimatedImage</h4>
						<p waBody="s" waColorText="quiet" waText>Animated image &#40;GIF/APNG/WebP&#41; with play/pause controls</p>
						<div class="wa-cluster wa-gap-xs"></div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-animated-image']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaImageCompare</h4>
						<p waBody="s" waColorText="quiet" waText>Before/after image comparison slider</p>
						<div class="wa-cluster wa-gap-xs"></div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-image-compare']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaComparison</h4>
						<p waBody="s" waColorText="quiet" waText>Side-by-side comparison component</p>
						<div class="wa-cluster wa-gap-xs"></div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-comparison']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaZoomableFrame</h4>
						<p waBody="s" waColorText="quiet" waText>Zoomable/pannable frame for images and content</p>
						<div class="wa-cluster wa-gap-xs"></div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-zoomable-frame']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaDialog</h4>
						<p waBody="s" waColorText="quiet" waText>Modal dialog with header, body, and footer slots. Supports open/close animation, light-dismiss, no-close-button, and overlay customization.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">4 props</wa-tag>
							<wa-tag pill variant="neutral">7 methods</wa-tag>
							<wa-tag pill variant="warning">5 events</wa-tag>
							<wa-tag pill variant="neutral">3 slots</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-dialog']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaDrawer</h4>
						<p waBody="s" waColorText="quiet" waText>Slide-out drawer panel with placement options, label, and light-dismiss support.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">5 props</wa-tag>
							<wa-tag pill variant="neutral">6 methods</wa-tag>
							<wa-tag pill variant="warning">5 events</wa-tag>
							<wa-tag pill variant="neutral">3 slots</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-drawer']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaTooltip</h4>
						<p waBody="s" waColorText="quiet" waText>Displays contextual information when hovering, focusing, or programmatically toggling on a target element.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">6 props</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-tooltip']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaPopover</h4>
						<p waBody="s" waColorText="quiet" waText>Floating panel with rich interactive content &#40;links, buttons, forms&#41;, anchored to an element. Only one popover can be open at a time.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">5 props</wa-tag>
							<wa-tag pill variant="neutral">8 methods</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-popover']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaPopup</h4>
						<p waBody="s" waColorText="quiet" waText>Low-level popup with anchor positioning, auto-size, and sync options</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">6 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-popup']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaToastContainer</h4>
						<p waBody="s" waColorText="quiet" waText>Toast notification container with stacking and placement</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">1 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-toast-container']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaToastItem</h4>
						<p waBody="s" waColorText="quiet" waText>Individual toast notification with variant, duration, and closable</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">3 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-toast-item']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaToastDataService</h4>
						<p waBody="s" waColorText="quiet" waText>Angular data service for programmatic toast creation and management</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-toast-data-service']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaProgressBar</h4>
						<p waBody="s" waColorText="quiet" waText>Linear progress bar with determinate/indeterminate modes, label, custom indicator color, and track height.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">5 props</wa-tag>
							<wa-tag pill variant="neutral">1 methods</wa-tag>
							<wa-tag pill variant="success">2 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-progress-bar']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaProgressRing</h4>
						<p waBody="s" waColorText="quiet" waText>Circular progress indicator with determinate/indeterminate modes.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">5 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-progress-ring']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaSpinner</h4>
						<p waBody="s" waColorText="quiet" waText>Loading spinner with size variants</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">1 props</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-spinner']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaSkeleton</h4>
						<p waBody="s" waColorText="quiet" waText>Skeleton loading placeholder with shimmer animation effect</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">2 props</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-skeleton']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaFormatBytes</h4>
						<p waBody="s" waColorText="quiet" waText>Formats byte values into human-readable sizes</p>
						<div class="wa-cluster wa-gap-xs"></div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-format-bytes']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaFormatDate</h4>
						<p waBody="s" waColorText="quiet" waText>Locale-aware date/time formatter</p>
						<div class="wa-cluster wa-gap-xs"></div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-format-date']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaFormatNumber</h4>
						<p waBody="s" waColorText="quiet" waText>Locale-aware number formatter with currency/percent/unit</p>
						<div class="wa-cluster wa-gap-xs"></div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-format-number']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaRelativeTime</h4>
						<p waBody="s" waColorText="quiet" waText>Relative time display &#40;e.g. '3 hours ago'&#41;</p>
						<div class="wa-cluster wa-gap-xs"></div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-relative-time']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaInclude</h4>
						<p waBody="s" waColorText="quiet" waText>Include external HTML content via URL</p>
						<div class="wa-cluster wa-gap-xs"></div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-include']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaAnimation</h4>
						<p waBody="s" waColorText="quiet" waText>CSS animation wrapper with play/pause/cancel controls</p>
						<div class="wa-cluster wa-gap-xs"></div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-animation']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaIntersectionObserver</h4>
						<p waBody="s" waColorText="quiet" waText>Detects when elements enter/exit the viewport</p>
						<div class="wa-cluster wa-gap-xs"></div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-intersection-observer']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaMutationObserver</h4>
						<p waBody="s" waColorText="quiet" waText>Watches for DOM mutations on child elements</p>
						<div class="wa-cluster wa-gap-xs"></div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-mutation-observer']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>WaResizeObserver</h4>
						<p waBody="s" waColorText="quiet" waText>Detects element size changes</p>
						<div class="wa-cluster wa-gap-xs"></div>
						<wa-button [routerLink]="['/frameworks/web-awesome/wa-resize-observer']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
	</div>
</div>